export default class Tracker {
	constructor() {
		this.gameTitle = '';

		this.loadStart = 0;
	}

	track(tag, params = {}) {
		if (!tag) {
			console.error('No Tag provided for game tracking');
			return;
		}

        params.pageName = window.location.hostname + window.location.pathname + window.location.search;
		params.interaction = tag;
		params.gamersid = process.env.NODE_ENV === 'production' ? 'turnerintgameben10omni' : 'turnerintgameben10omnidev';
		params.gametitle = this.gameTitle;
		params.gamecategory = 'puzzle';
		params.englishname = 'ben 10 omnicode';

		let event = {
			type : 'game',
			data : Object.assign({}, params)
		};

		console.log(tag, event);
		// eslint-disable-next-line no-undef
		turner_metadata.trackAction.push(event);
	}
}
